import React, { Children } from 'react'
import PropTypes from 'prop-types'
import { IconButton, ListItem, ListItemIcon, ListItemText, Skeleton } from '@mui/material'

const WorkOrderSkeleton = ({ rows = 1 }) => {
  const shimmersArray = new Array(rows).fill()

  return Children.toArray(
    shimmersArray.map((_, index) => (
      <ListItem divider={index !== rows - 1}>
        <ListItemIcon sx={{ minWidth: 'auto', mr: 1 }}>
          <IconButton>
            <Skeleton width="1.5rem" />
          </IconButton>
        </ListItemIcon>
        <ListItemText primary={<Skeleton width="5rem" height="2.5rem" />} />
      </ListItem>
    ))
  )
}

WorkOrderSkeleton.propTypes = {
  rows: PropTypes.number,
}

export default WorkOrderSkeleton
